import App from "@frog/source/models/App.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import World from "@frog/source/models/World.js"

import convertOldChapterScripting from "@frog/source/data/games/hero/convertOldChapterScripting.js"

export default {
    "slug": "upgrade-archer",
    "stage": {
        "image": require("./image.png"),
        "units": require("./units.json"),
        "world": World.parse({
            "encounters": require("./encounters.json"),
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
        }),
        "text": function(stage) {
            return "Your friend is surrounded! Save them."
        },
        "conditions": convertOldChapterScripting({
            "1:end": [
                {
                    "type": "SpawnUnit",
                    "spawn": {
                        "key": "#1",
                        "position": {"x": 2, "y": -1},
                        "classKey": "berserker",
                        "affiliation": "bad",
                    },
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 2, "y": 0},
                    "classKey": "#1",
                }
            ],
            "3:end": [
                {
                    "type": "SpawnUnit",
                    "spawn": {
                        "key": "#2",
                        "position": {"x": -1, "y": 4},
                        "classKey": "archer",
                        "affiliation": "bad",
                    },
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 0, "y": 4},
                    "classKey": "#2",
                },
                {
                    "type": "SpawnUnit",
                    "spawn": {
                        "key": "#3",
                        "position": {"x": 6, "y": 3},
                        "classKey": "rogue",
                        "affiliation": "bad",
                    },
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 5, "y": 3},
                    "classKey": "#3",
                }
            ],
            // "7:end": [
            //     {
            //         "type": "SpawnUnit",
            //         "spawn": {
            //             "key": "#4",
            //             "position": {x: 3, y: -1},
            //             "classKey": "rogue",
            //             "affiliation": "bad",
            //         },
            //     },
            //     {
            //         "type": "MoveUnit",
            //         "position": {x: 3, y: 0},
            //         "classKey": "#4",
            //     }
            // ],
        }, [
            {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
            {"type": "FinishLocation", "locationKey": "B"},
        ])
    },
}

// // https://serenesforest.net/wp-content/uploads/2017/02/13.png
// "upgrade-archer": {
//     "music": "hero-alt",
//     "hasPreparation": false,
//     "map": {
//         "width": 6,
//         "height": 8,
//         "image": require("@frog/source/assets/images/hero-tactics/stages/border.png"),
//         "tiles": [
//             {"position": {"x": 0, "y": 5}, "passable": false},
//             {"position": {"x": 1, "y": 5}, "passable": false},
//             {"position": {"x": 4, "y": 5}, "passable": false},
//             {"position": {"x": 5, "y": 5}, "passable": false},
//             // {"position": {x: 5, y: 6}, "passable": false},
//             // {"position": {x: 5, y: 7}, "passable": false},
//             // {"position": {x: 4, y: 7}, "passable": false},
//             {"position": {"x": 0, "y": 6}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/desert/objects/obelisk.png"), "size": {"x": 1, "y": 2}},
//             {"position": {"x": 5, "y": 6}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/desert/objects/obelisk-right.png"), "size": {"x": 1, "y": 2}},
//             {"position": {"x": 4, "y": 3}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/desert/objects/cactus_1.png")},
//             {"position": {"x": 1, "y": 1}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/desert/objects/cactus_2.png")},
//             {"position": {"x": 5, "y": 0}, "passable": true, "image": require("@frog/source/assets/images/hero-tactics/map/desert/objects/bones_1.png")},
//         ]
//     },
//     "spawns": [
//         {"position": {"x": 3, "y": 2}, "affiliation": "good"},
//         {"position": {"x": 2, "y": 6}, "affiliation": "good"},
//         {"position": {"x": 3, "y": 6}, "affiliation": "good"},
//         {"position": {"x": 3, "y": 0}, "affiliation": "good"},
//         {"position": {"x": 5, "y": 1}, "affiliation": "bad", "classKey": "berserker"},
//         {"position": {"x": 5, "y": 4}, "affiliation": "bad", "classKey": "rogue"},
//         {"position": {"x": 2, "y": 0}, "affiliation": "bad", "classKey": "rogue"},
//         {"position": {"x": 0, "y": 3}, "affiliation": "bad", "classKey": "berserker"},
//     ],
//     "events": {
//         "1:end": [
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#1",
//                     "position": {"x": 4, "y": -1},
//                     "classKey": "berserker",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 4, "y": 0},
//                 "classKey": "#1",
//             }
//         ],
//         "3:end": [
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#2",
//                     "position": {"x": -1, "y": 4},
//                     "classKey": "archer",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 0, "y": 4},
//                 "classKey": "#2",
//             }
//         ],
//         "5:end": [
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#3",
//                     "position": {"x": 6, "y": 3},
//                     "classKey": "rogue",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 5, "y": 3},
//                 "classKey": "#3",
//             }
//         ],
//         // "7:end": [
//         //     {
//         //         "type": "SpawnUnit",
//         //         "spawn": {
//         //             "key": "#4",
//         //             "position": {x: 3, y: -1},
//         //             "classKey": "rogue",
//         //             "affiliation": "bad",
//         //         },
//         //     },
//         //     {
//         //         "type": "MoveUnit",
//         //         "position": {x: 3, y: 0},
//         //         "classKey": "#4",
//         //     }
//         // ],
//     },
//     "afterVictory": [
//         {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
//         {"type": "FinishLocation", "locationKey": "B"},
//     ],
//     "nextUrl": "/games/hero/chapters/defeat-miniboss",
// },
